import {
  INTERVENTION_TYPE_AFFICHAGE,
  INTERVENTION_TYPE_INTERVENTION,
  INTERVENTION_TYPE_NON_DEFINI,
  ETAT_NOUVEAU,
  ETAT_VALIDE,
} from '@/configuration/logistique/intervention/interventionConf';

export default function genererCritereRechercheIntervention() {
  return {
    auto: null,
    types: [
      INTERVENTION_TYPE_INTERVENTION,
      INTERVENTION_TYPE_AFFICHAGE,
      INTERVENTION_TYPE_NON_DEFINI,
    ],
    societeId: null,
    dateCreationTime: {
      dateDebut: null,
      dateFin: null,
    },
    datePlanification: {
      dateDebut: null,
      dateFin: null,
    },
    code: null,
    patrimoineAdresseLibelle: null,
    etats: [
      ETAT_NOUVEAU,
      ETAT_VALIDE,
    ],
    sources: [],
    demandeurIds: [],
    agencesIds: [],
    typeOtIds: [],
    sansParent: true,
    otIds: [],
    adresses: [],
    villes: [],
    codesPostaux: [],
  };
}
